import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { accountsStateSelector } from "./accountsStateSelector";

export const accountsFilterValueSelector = createDraftSafeSelector(
  [accountsStateSelector],
  (accountsState) => accountsState.filterValue,
);
